/* eslint no-console:"off" */

// We need to access to global console here, since Ember.Logger is deprecated
// and console.log(), console.debug(), etc. is the preferred way of logging now.
// See: https://deprecations-app-prod.herokuapp.com/deprecations/v3.x/#toc_ember-console-deprecate-logger
// eslint-disable-next-line unicorn/no-static-only-class
export default class Logger {
  static debug(...args) {
    if (typeof console !== 'undefined' && typeof console.debug === 'function') {
      console.debug(...args);
    }
  }
  static error(...args) {
    if (typeof console !== 'undefined' && typeof console.error === 'function') {
      console.error(...args);
    }
  }
  static info(...args) {
    if (typeof console !== 'undefined' && typeof console.info === 'function') {
      console.info(...args);
    }
  }
  static log(...args) {
    if (typeof console !== 'undefined' && typeof console.log === 'function') {
      console.log(...args);
    }
  }
  static warn(...args) {
    if (typeof console !== 'undefined' && typeof console.warn === 'function') {
      console.warn(...args);
    }
  }
}